import { Tooltip as AntTooltip, type TooltipProps as AntTooltipProps } from 'antd';
import { useFela } from 'react-fela';

import { container } from './Tooltip.rules';

interface CommonProps {
    customOverlayStyle?: typeof container;
}

type GetTooltipProps<
    TooltipProps extends {
        overlayClassName?: string;
    },
> = Omit<TooltipProps, 'overlayClassName'> & CommonProps;

export type TooltipProps = GetTooltipProps<AntTooltipProps>;

export const Tooltip = ({ customOverlayStyle, ...props }: TooltipProps) => {
    const { css } = useFela();

    return <AntTooltip {...props} classNames={{ root: css(container, customOverlayStyle) }} />;
};
